import { SIPackageId } from "app/common/after-trial/packageIds";
import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

const createAfterTrialEntryModalTrackingService = (track: TrackFn) => ({
    trackEntryModalShow(): void {
        track("AfterTrialModal", "show", "si.after_trial.entry_modal");
    },
    trackUpgradeNowClick(): void {
        track("AfterTrialModal", "click", "si.after_trial.entry_modal/upgrade_now");
    },
    trackSiUpgradePackageClick(billingPeriod: string): void {
        track("AfterTrialModal", "click", `choose package/${SIPackageId}/${billingPeriod}`);
    },
    trackContactUsClick(): void {
        track("AfterTrialModal", "click", "si.after_trial.entry_modal/contact_us");
    },
    trackCloseModalClick(): void {
        track("AfterTrialModal", "click", "si.after_trial.entry_modal/close");
    },
});

export default createAfterTrialEntryModalTrackingService;
